
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance/staking",
      function () {
        return require("private-next-pages/finance/staking.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance/staking"])
      });
    }
  